import { Tooltip } from 'react-tooltip';

import parse from 'html-react-parser';

import UsersArray from 'modules/profile/components/UsersArray';
import { useTranslate } from 'hooks/useTranslate';
import {
  getDateTime,
  getRecipientsText,
} from 'modules/communications/components/utils';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';
import { getRecipientsToolTipText } from '../utils/getRecipientsTooltipText';

const CommunicationDataSection = () => {
  const { t } = useTranslate();
  const { data } = useCommunicationDetailsPage();
  const { communication } = data;

  const recipientsText = getRecipientsText(
    communication?.recipients,
    communication?.presetGroup
  );

  const recipientsTooltipText = getRecipientsToolTipText(
    communication?.recipients || []
  );

  const parsedBody = communication?.body ? parse(communication.body) : '';
  const date = communication?.date ? getDateTime(communication.date) : '';

  return (
    <div className="m-0">
      <div className="nk-reply-header nk-ibx-reply-header is-shown">
        <div className="nk-reply-desc">
          <div className="ml-1">
            {/* @ts-ignore */}
            <UsersArray
              users={communication?.recipients}
              show={1}
              size="w-40px"
              bgColor="bg-primary"
            />
          </div>
          <div className="nk-reply-info">
            <div className="nk-reply-author lead-text">
              {communication?.sender?.email}
              <span className="date d-sm-none">{date}</span>
            </div>
            <div
              className="dropdown nk-reply-msg-info dropdown-toggle sub-text dropdown-indicator"
              id="tooltip-recipients"
              data-toggle="dropdown"
            >
              {t('EmailTo')} {recipientsText}
              <Tooltip anchorId="tooltip-recipients" place="bottom">
                <div>
                  <ul>{recipientsTooltipText}</ul>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
        <ul className="nk-reply-tools g-1">
          {data.attachedDocuments?.length > 0 && (
            <li className="attach-msg">
              <em className="icon ni ni-clip-h" />
            </li>
          )}
          <li className="date-msg">
            <span className="date">{date}</span>
          </li>
        </ul>
      </div>
      <div className="nk-reply-entry entry my-3">
        <div
          style={{
            whiteSpace: typeof parsedBody === 'string' ? 'pre-line' : 'normal',
          }}
        >
          {parsedBody || ''}
        </div>
      </div>
    </div>
  );
};

export default CommunicationDataSection;
